<template>
    <v-sheet>
        <v-sheet v-if="loading">
            <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
        </v-sheet>
        <v-sheet v-else>
            <v-hover><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
            </v-hover>
            <BasicCard v-bind:title="`Anagrafica strumento`" >
                <RowComponent
                    v-bind:label="`famiglia`"
                    v-bind:value="p_families[instrument.family].label">
                </RowComponent>
                <RowComponent
                    v-bind:label="`numero seriale`"
                    v-bind:value="instrument.serno">
                </RowComponent>
                <RowComponent
                    v-bind:label="`marca`"
                    v-bind:value="instrument.manufacturer">
                </RowComponent>
                <RowComponent
                    v-bind:label="`modello`"
                    v-bind:value="instrument.model">
                </RowComponent>
                <RowComponent
                    v-bind:label="`codice cliente/nome`"
                    v-bind:value="instrument.name">
                </RowComponent>
                <RowComponent
                    v-bind:label="`descrizione`"
                    v-bind:value="instrument.description">
                </RowComponent>
                <div>&nbsp;
                    <AuthorInfo
                        :key="instrument.updated"
                        :created="instrument.created"
                        :created_by="instrument.created_by"
                        :updated="instrument.updated"
                        :updated_by="instrument.updated_by"/>
                </div>
            </BasicCard>
            <BasicCard v-bind:title="`Dettagli primario`" >
                <RowComponent
                    v-bind:label="`Ente proprietario`"
                    v-bind:value="org.name">
                </RowComponent>
                <RowComponent
                    v-bind:label="`Disponibile per`"
                    :value="`ss`">
                    <template v-slot:value>
                    <div v-for="o of dest_orgs" :key="o._id">
                        {{o.name}}
                    </div>
                    </template>
                </RowComponent>
                <RowComponent
                    v-bind:label="`Certificato`"
                    >
                    <span class="body-2">n° <b>{{instrument.primary_data.certificate_nr}}</b> 
                        del <b>{{formatDatefromTS(instrument.primary_data.emission)}}</b><br/>
                        emesso da <b>{{instrument.primary_data.certificate_authority}}</b><br/>
                        scadenza <b>{{formatDatefromTS(instrument.primary_data.expire)}}</b><br/>
                        <v-btn :href="getCertPath()+''+instrument.primary_data.certificate_ref" target="_blank"><v-icon>get_app</v-icon>Download</v-btn>
                    </span>
                </RowComponent>
                <RowComponent
                    v-bind:label="`Certificato intermedio`"
                    v-if="instrument.primary_data.intermediate_certificate_ref"
                    >
                    <span class="body-2">n° <b>{{instrument.primary_data.intermediate_certificate_nr}}</b> 
                        del <b>{{formatDatefromTS(instrument.primary_data.intermediate_emission)}}</b><br/>
                        emesso da <b>{{instrument.primary_data.intermediate_certificate_authority}}</b><br/>
                        scadenza <b>{{formatDatefromTS(instrument.primary_data.intermediate_expire)}}</b><br/>
                        <v-btn :href="getCertPath()+''+instrument.primary_data.intermediate_certificate_ref" target="_blank"><v-icon>get_app</v-icon>Download</v-btn>
                    </span>
                </RowComponent>
            </BasicCard>
            <v-alert class="my-4" type="warning" v-if="errorMessage">Caricamento certificati: {{ errorMessage }}</v-alert>
            <BasicCard v-bind:title="`Storico certificati`" v-if="certs.length > 0">
                <div v-for="(cert,idx) of certs" :key="idx" class="d-flex align-center full-width pa-2"><div>
                    <v-btn text fab small color="primary" :href="getCertPath()+''+cert.href" target="_blank"><v-icon>visibility</v-icon></v-btn>
                    nr. <span class="font-weight-bold">{{cert.cert_nr}}</span> 
                    emesso il <span class="font-weight-bold">{{cert.emission | formatDateTS }}</span>
                    da <span class="font-weight-bold"> {{cert.cert_authority }}</span>
                    <span class="caption font-italic"> (ultimo aggiornamento: {{cert.updated | formatDateTS}})</span> </div>
                </div>
            </BasicCard>
            <!--BasicCard v-bind:title="`Storico prestiti`">
                <v-data-table
                    :items="loans"
                    :hide-default-footer="true"
                    :hide-default-header="true"
                    :disable-pagination="true"
                    dense>
                    <template v-slot:body="{ items }">
                        <tbody >
                            <div v-if="loans.length == 0" class="px-2 text-h6 text-center">
                                Nessun prestito
                            </div>
                            <tr class="pa-0 ma-0" v-for="loan in items" :key="loan._id">
                                <td>
                                    <LoanItem
                                        :key="loan._id"
                                        :loan_id="loan._id"
                                        >
                                    </LoanItem>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </BasicCard-->
            <BasicCard title="Dati">
                <div>
                    <dynamiclink
                    :data="dynamic_block"
                    :preview="true"
                    />
                </div>
            </BasicCard>
            <BasicCard v-if="reports">
                <template v-slot:title>
                    <div class="d-flex flex-grow-1 text-left" @click="c_expand.report=!c_expand.report">
                        Report
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.report=!c_expand.report">
                        <v-icon v-if="c_expand.report">expand_less</v-icon>
                        <v-icon v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.report">
                    <div v-if="reports_uncomplete && reports_uncomplete.length>0">
                        <div class="pa-2 text-h6 text-uppercase">Non completi</div>
                        <ReportItem
                            v-for="report of reports_uncomplete"
                            :key="report._id"
                            :report_id="report._id"
                            :show_instrument="false"
                            class="px-2">
                        </ReportItem>
                    </div>
                    <div v-if="Object.keys(reports).length>0">
                        <div class="pa-2 text-h6 text-uppercase">Completi</div>
                    </div>
                    <div v-for="key of Object.keys(reports)" :key="key">
                        <div v-if="key != 'uncomplete'">
                            <div v-if="reports[key] && reports[key].length>0" class="pa-2 text-subtitle-1">
                                {{ report_obj[key].name }}
                            </div>
                            <ReportItem
                                v-for="report of reports[key]"
                                :key="report._id"
                                :report_id="report._id"
                                :show_instrument="false"
                                class="px-2">
                            </ReportItem>
                        </div>
                    </div>    
                </div>
            </BasicCard>
        </v-sheet>
        </v-sheet>
</template>

<script>
// import _ from 'lodash'
import BasicCard from '../../components/utils/Basic_card.vue'
import AuthorInfo from '../../components/utils/AuthorInfo'
import RowComponent from '../../components/utils/RowComponent.vue'
import dynamiclink from "../../components/utils/Instrument_d_link"
import ReportItem from "../reports/ReportItem"
import {p_families, report_type, } from "../../utils/common.js"
import {formatDatefromTS, getCertificatePath} from "../../utils/commonUtils.js"
import {searchDesign, orderByFields} from "../../utils/dbUtility"

export default {
    components: { BasicCard, RowComponent, dynamiclink, AuthorInfo, ReportItem },
    props: {
        i_id: {
            type: String,
            required: true,
            default: ''  // TODO DEBUG-ONLY
        },
        back: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            instrument: null,
            valid: true,
            org: null,
            dest_orgs: [],
            certs: [],
            report_obj: report_type,
            reports: {},
            reports_uncomplete: [],
            tol_dict: {},
            c_expand: {
                report: false,
            },
            formatDatefromTS,
            loading: true,
            dynamic_block: {},
            errorMessage: null,
            p_families: p_families
        }
    },
    computed: {
    },
    methods: {
        close(){
            this.$router.push({path: this.back})
        },
        getCertPath() {
            return getCertificatePath()
        },
        async searchReports(){
            this.reports = {}
            let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', ['primary', this.instrument._id], false)
            if (res.length > 0) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                res = _.groupBy(res, function(rep) {
                    if (!['ready', 'ready_failed', 'signed'].includes(rep.value.status)){
                        return 'uncomplete'
                    } else {
                        return rep.value.op_type
                    }
                })
                for (let key of Object.keys(res)){
                    if (key == 'uncomplete') {
                        this.reports_uncomplete = orderByFields(res[key], {value: ['value.report_date', 'value.review_date'], order: ['desc', 'desc']})
                    } else {
                        const tmp = res[key].filter((item) => { return (item.value['report_date'] >= this.instrument.primary_data.emission) && (Object.keys(report_type)).includes(item.value['op_type'])})
                        this.reports[key] = orderByFields(tmp, {value: ['value.report_date', 'value.review_date'], order: ['desc', 'desc']})
                    }
                }
            } else {
                this.reports = null
            }
        },
    },

    

    async mounted() {
        this.loading = true 
        this.errorMessage = null
        let res = await this.$store.state.$pouch.get('registry', this.i_id)
        if (res) {
            this.instrument = res
            this.org = await this.$store.state.$pouch.get('registry', this.instrument.org_id)
            let tmp = await this.$store.state.$pouch.allDocs('registry', {keys: [this.instrument.used_by]})
            this.dest_orgs = _.map(tmp.rows, 'doc')
            console.log("*****", tmp, this.dest_orgs)
            this.dynamic_block = {
                block: p_families[this.instrument.family], 
                manufacturer: this.instrument.manufacturer, 
                instrument: this.instrument_id, 
                p_data: this.instrument.primary_data.data
            }
            
            try {
                let res = await this.axios.get("/mastercal/instruments/history_by_cert/"+ this.i_id).catch(error => {
                    console.log("error status", error);
                    this.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
                });
                let data = _.sortBy(res.data, 'id')
                //res.data.sort()
                console.log('RES', data)
                this.certs = _.forEach(data, function(cert) {
                    console.log(cert)
                    let a = cert.id.split(':')
                    return Object.assign(cert, {
                       'emission': parseInt(a[0]),
                       'cert_nr': a[1],
                       'cert_authority': a[2]
                    })
                })
                console.log('CERTS', this.certs)
            } catch(err) {
                this.certs = []
                console.log("ERROR GETTING CERTIFICATES", err)
            }
            await this.searchReports()
        }
        this.loading = false
    },
    
}
</script>

<style>

</style>
